import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  inject,
} from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";

import { FileUploader, FileUploadModule } from "ng2-file-upload";
import { HttpClient, HttpEventType, HttpResponse } from "@angular/common/http";

import {
  FalseClaimsMetricDataType,
  MetricDataType,
  PowertrainName,
  YTDMetricDataType,
} from "./powertrain.model";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { PiezeoDashboardService } from "../../../app/services/piezo-dashboard.service";

@Component({
  selector: "app-powertrain-modal",
  templateUrl: "./powertrain-modal.component.html",
  styleUrls: ["./powertrain-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, FormsModule,MatIcon,FileUploadModule ],
})
export class PowertrainModalComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() data: any;
  @Output() closeBox: EventEmitter<
    | MetricDataType
    | YTDMetricDataType
    | FalseClaimsMetricDataType
    | PowertrainName
    | any
  > = new EventEmitter();
  @Input() imrSrc: string;

  @Output() closePlateDetailsModal: EventEmitter<boolean> = new EventEmitter();
  @Output() closePowertrainImgModal: EventEmitter<null> = new EventEmitter();
  @Output() closePowertrainPhyImgModal: EventEmitter<any> = new EventEmitter();
  @Output() closeCommissionDate: EventEmitter<any> = new EventEmitter();
  @Output() closeOutForServiceModal: EventEmitter<any> = new EventEmitter();
  @Output() closeYTDBox: EventEmitter<any> = new EventEmitter();

  //URLS
  updatePerformanceMetricsUrl: string =
    BaseUrlConstantsService.POWERTRAIN_PERFORMANCE_METRICS_API;
  updateYTDMetricsUrl: string =
    BaseUrlConstantsService.POWERTRAIN_YTD_METRICS_API;
  updateFalseClaimsMetricsUrl: string =
    BaseUrlConstantsService.POWERTRAIN_FLASE_CLAIMS_API;
  updateSensornamesUrl =
    BaseUrlConstantsService.POWERTRAIN_UPDATE_POSITIONS_URL;
  powertrain_base_url =
    BaseUrlConstantsService.POWERTRAIN;
  public imageUploadUrl = BaseUrlConstantsService.POWERTRAIN_IMAGE_UPLOAD;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public deletePhyImg = BaseUrlConstantsService.POWERTRAIN_PHYSICAL_IMG;

  //Edit Sensor Names
  isEditingSensor = false;
  currEditSensor: any = {};
  isEditingSuccess = false;

  //forms
  performanceMetricsForm: FormGroup = new FormGroup({
    availability: new FormControl(),
    performance: new FormControl(),
  });
  YTDMetricsForm: FormGroup = new FormGroup({
    unexpected_failures: new FormControl(),
    failures_cost: new FormControl(),
  });
  YTDMetricsFormV2: FormGroup = new FormGroup({
    cost: new FormControl(null,{
      validators:[Validators.required,Validators.min(0)]
    }),
    start_date: new FormControl(this.getTodayFormatted(),[Validators.required,this.startDateValidator.bind(this)]),
    end_date: new FormControl(null,[Validators.required,this.endDateValidator.bind(this)]),
  });

  flaseClaimsMetricsForm: FormGroup = new FormGroup({
    positives: new FormControl(),
    negatives: new FormControl(),
  });

  motorTypeForm: FormGroup = new FormGroup({
    type: new FormControl("INDUCTION_MOTOR", {
      validators: [Validators.required],
    }),
  });

  powertrainNameForm: FormGroup = new FormGroup({
    powertrain_name: new FormControl("", {
      validators: [Validators.required, Validators.minLength(5)],
    }),
  });

  sensorNameForm: FormGroup = new FormGroup({
    sensorDNames: new FormControl("", {
      validators: [Validators.required],
    }),
    sensorMarker: new FormControl("", {
      validators: [Validators.required],
    }),
  });

  sensorTypeForm: FormGroup = new FormGroup({
    assetType: new FormControl("", { validators: [Validators.required] }),
    subType: new FormControl(""),
    assetMarker: new FormControl("CHILD"),
    sensorMarker: new FormControl("", {
      validators: [Validators.required],
    }),
    sensorDNames: new FormControl("", {
      validators: [Validators.required, Validators.maxLength(9)],
    }),
  });

  piezoSensorTypeForm: FormGroup = new FormGroup({
    master_type: new FormControl("", { validators: [Validators.required] }),
    assetType: new FormControl("", { validators: [Validators.required] }),
    subType: new FormControl(""),
    assetMarker: new FormControl("CHILD"),
    sensorMarker: new FormControl("", {
      validators: [Validators.required],
    }),
    sensorDNames: new FormControl("", {
      validators: [Validators.required, Validators.maxLength(9)],
    }),
  });

  sensors: any = [];

  uploadLoader = false;

  sensorpositionUrl = BaseUrlConstantsService.POWERTRAIN_API_SENSORS_POSITION;
  addPhyImgUrl = BaseUrlConstantsService.POWERTRAIN_PHYSICAL_IMG;
  oldParamsSubscription = new Subscription();

  @Input("subsystem_id") subsystem_id: number | string;

  powertrainImg: string;
  powertrainName: string;
  sensors_img_modal: any = [];
  assetIds = [];
  oldParams: any = null;
  powertrainObj: any = null;
  client_id: string = null;
  showModal = false;
  public uploader: FileUploader;
  public _imgUrl: string = "";

  commission_date: string;
  piezo_srv = inject(PiezeoDashboardService);
  peizo_subsystem_data;
  piezo_sensors=[]

  constructor(private service: PowerTrainService,private toast: BackendApiService,private router: Router,private http: HttpClient,private srv: BackendApiService) {
    this.uploader = new FileUploader({
      url: BaseUrlConstantsService.POWERTRAIN_IMAGE_UPLOAD,
      // url: "http://localhost:3015/images/powertrain",
      itemAlias: "photo",
    });
  }

  ngOnInit(): void {
      this.service.powertrainSensorsDataObs.subscribe((data) => {
        this.sensors = data;
      });
      if (this.type == 'piezo_powertrain_image') {
        this.peizo_subsystem_data = this.piezo_srv.getSubsystemData();
        this.piezo_sensors=JSON.parse(this.peizo_subsystem_data.device_position);
      }

      this.checkPerformanceMetricsModal();
      this.checkYTDMetricsModal();
      this.checkFalseClaimsMetricsModal();
      this.checkPowertrainNameModal();
      this.initializeUploader();
      this.fetchSensorsPositions();
      this.oldParamsSubscription = this.service.oldDashboardParamsObs.subscribe(
        (params) => {
          this.oldParams = JSON.parse(params)[0];
        }
      );
      this.checkAssetTypeForm();
  }

  ngOnDestroy(): void {
    this.oldParamsSubscription.unsubscribe();
  }

  /* --------------------------------------------------------PERFORMANCEFORM STARTS---------------------------------------------------------------------------- */
  checkPerformanceMetricsModal() {
    if (this.type == "performanceMetrics") {
      this.createPerformanceMetricsForm();
    }
  }

  createPerformanceMetricsForm() {
    this.performanceMetricsForm = new FormGroup({
      availability: new FormControl(this.data.asset_availability, {
        validators: [
          Validators.required,
          Validators.max(100),
          Validators.min(0),
        ],
      }),
      performance: new FormControl(this.data.asset_performance, {
        validators: [
          Validators.required,
          Validators.max(100),
          Validators.min(0),
        ],
      }),
    });
  }

  submitPerformanceMetricsForm() {
    let performance = this.performanceMetricsForm.value.performance;
    let availability = this.performanceMetricsForm.value.availability;
    let OEE = (performance / availability) * 100;

    let body = {
      assetAvailability: availability,
      assetPerformance: performance,
      assetOEE: OEE,
      client_id: this.data.client_id,
      subsystem_id: this.data.subsystem_id,
      mastergid: this.data.gid,
    };

    this.service
      .updatePerformanceMetrics(
        this.updatePerformanceMetricsUrl + this.data.subsystem_id,
        body
      )
      .then((_) => {
        this.toast.showSuccess("Performance metrics updated");
        this.closeBox.emit({
          updatedData: { availability, performance, OEE },
        });
      })
      .catch((_) => {
        this.toast.showError("Failed to update Performance metrics");
      });
  }
  /* --------------------------------------------------------PERFORMANCE FORM ENDS---------------------------------------------------------------------------- */

  /* --------------------------------------------------------YTD FORM STARTS---------------------------------------------------------------------------- */
  checkYTDMetricsModal() {
    if (this.type == "ytdMetrics") {
      this.createYTDMetricsForm();
    }
  }

  createYTDMetricsForm() {
    this.YTDMetricsForm = new FormGroup({
      unexpected_failures: new FormControl(
        parseInt(this.data.unexpected_failures.replace("₹", ""), 10),
        {
          validators: [
            Validators.required,
            Validators.max(100),
            Validators.min(0),
          ],
        }
      ),
      failures_cost: new FormControl(
        parseInt(this.data.failures_cost.replace("₹", ""), 10),
        {
          validators: [
            Validators.required,
            Validators.max(100),
            Validators.min(0),
          ],
        }
      ),
    });
  }

  submitYTDMetricsForm() {
    let unexpected_failures = this.YTDMetricsForm.value.unexpected_failures;
    let failures_cost = this.YTDMetricsForm.value.failures_cost;
    let net_failures_cost = (unexpected_failures / failures_cost) * 100;

    let body = {
      unexpected_failures,
      failures_cost,
      net_failures_cost,
      client_id: this.data.client_id,
      subsystem_id: this.data.subsystem_id,
    };

    this.service
      .updatePerformanceMetrics(
        this.updateYTDMetricsUrl + this.data.subsystem_id,
        body
      )
      .then((_) => {
        this.toast.showSuccess("YTD metrics updated");
        this.closeBox.emit({
          updatedData: {
            unexpected_failures,
            failures_cost,
            net_failures_cost,
          },
        });
      })
      .catch((_) => {
        this.toast.showError("Failed to update YTD metrics");
      });
  }

  /* --------------------------------------------------------YTD FORM ENDS------------------------------------------------------------------------------ */

  /* --------------------------------------------------------FALSE CLAIMS FORM STARTS------------------------------------------------------------------------------ */

  checkFalseClaimsMetricsModal() {
    if (this.type == "falseClaimsMetrics") {
      this.createFalseClaimsMetricsForm();
    }
  }

  createFalseClaimsMetricsForm() {
    this.flaseClaimsMetricsForm = new FormGroup({
      positives: new FormControl(
        parseInt(this.data.positives.replace("%", ""), 10),
        {
          validators: [
            Validators.required,
            Validators.max(100),
            Validators.min(0),
          ],
        }
      ),
      negatives: new FormControl(
        parseInt(this.data.negatives.replace("%", ""), 10),
        {
          validators: [
            Validators.required,
            Validators.max(100),
            Validators.min(0),
          ],
        }
      ),
    });
  }

  submitFalseClaimsMetricsForm() {
    let positives = this.flaseClaimsMetricsForm.value.positives;
    let negatives = this.flaseClaimsMetricsForm.value.negatives;
    let uptime = (positives / negatives) * 100;

    // let body = {
    //   positives,
    //   negatives,
    //   uptime,
    //   client_id: this.data.client_id,
    //   subsystem_id: this.data.subsystem_id,
    // };
    let body={
    "unverified_alerts": positives,
    "not_generated_alerts": negatives
    }

    this.service
      .updateFalseClaimsMetrics(`${this.updateFalseClaimsMetricsUrl}${this.subsystem_id}`, body)
      .then((_) => {
        this.toast.showSuccess(" Data updated successfully");
        this.closeBox.emit({
          updatedData: {
            positives,
            negatives,
            uptime,
          },
        });
      })
      .catch((_) => {
        this.toast.showError("Failed to update data");
      });
  }
  /* --------------------------------------------------------FALSE CLAIMS FORM ENDS------------------------------------------------------------------------------ */
  selectMotorType() {
    this.closeBox.emit(this.motorTypeForm.value);
  }

  checkAssetTypeForm() {
    if(this.type=='piezo_asset_selection'){
      // HYBRID PIEZO+EMSAVER PTrain
      if (this.data?.isMaster == 0)
        this.piezoSensorTypeForm.get("assetMarker").setValue("MASTER");
      this.piezoSensorTypeForm.patchValue({sensorMarker: this.data.isMaster == 0 ? "BASE" : this.data.isMaster,});
    }else{
      // PURE EMSAVER POWERTRAIN
      if (this.data?.isMaster == 0)
        this.sensorTypeForm.get("assetMarker").setValue("MASTER");
      this.sensorTypeForm.patchValue({sensorMarker: this.data.isMaster == 0 ? "BASE" : this.data.isMaster,});
    }
  }

  /**
   * Emits the selected powertrain sensor type and closes the modal.
   *
   * This function retrieves the current value of the sensor type form and emits it using the `closeBox` event emitter.
   * It also closes the modal by calling `closeBox.emit()`.
   *
   * @returns {void}
   */
  selectPowertrainSensorType(): void {
    this.closeBox.emit({
      ...this.sensorTypeForm.value,
      sensor_number: this.data.isMaster,
    });
  }
  /**
   * Emits the selected powertrain sensor type and closes the modal.
   *
   * This function retrieves the current value of the sensor type form and emits it using the `closeBox` event emitter.
   * It also closes the modal by calling `closeBox.emit()`.
   *
   * @returns {void}
   */
  selectPiezoPowertrainSensorType(): void {
    this.closeBox.emit({
      ...this.piezoSensorTypeForm.value,
      sensor_number: this.data.isMaster,
    });
  }

  get assetTypeValue(): string {
    return this.piezoSensorTypeForm.get("assetType")?.value;
  }

  inputpowertrainForm() {
    this.closeBox.emit({
      name: this.powertrainNameForm.value.powertrain_name,
      overlay: false,
    });
  }
  closePowertrainNameModal() {
    this.closeBox.emit({ name: "", overlay: true });
  }

  closePowertrainDeleteModal(deleting) {
    this.closeBox.emit({ deleted: deleting });
  }

  closeModal() {
    this.closeBox.emit();
  }

  /* --------------------------------------------------------POWERTRAIN NAME STARTS------------------------------------------------------------------------------ */
  checkPowertrainNameModal() {
    if (this.type == "powertrain_name") {
      this.powertrainNameForm.get("powertrain_name").setValue(this.data.name);
    }
  }
  /* --------------------------------------------------------POWERTRAIN NAME ENDS------------------------------------------------------------------------------ */
  /* --------------------------------------------------------POWERTRAIN PLATE DETAIlS STARTS------------------------------------------------------------------------------ */

  closePlateDetailsModalBox() {
    this.closePlateDetailsModal.emit(this.isEditingSuccess);
  }

  editSensor(sensor: any) {
    this.isEditingSensor = true;
    this.currEditSensor = sensor;
    this.sensorNameForm.patchValue({
      sensorDNames: this.currEditSensor.sensorDNames,
      sensorMarker: this.currEditSensor.sensorMarker,
    });
  }

  saveSensorName() {
    this.currEditSensor = {
      ...this.currEditSensor,
      sensorDNames: this.sensorNameForm.value.sensorDNames,
      sensorMarker: this.sensorNameForm.value.sensorMarker,
    };
    this.sensors = this.sensors.map((sensor) => {
      if (sensor.asset_id == this.currEditSensor.asset_id)
        return this.currEditSensor;
      else return sensor;
    });
    this.service
      .updateSensorsPosition(
        `${this.sensorpositionUrl}${this.data.subsystem_id}`,
        {
          subsystem_name: this.data.subsystem_name,
          device_position: this.sensors,
        }
      )
      .then((data: any) => {
        this.currEditSensor = {};
        this.isEditingSuccess = true;
        this.isEditingSensor = false;
        this.sensorNameForm.reset();
      })
      .catch((err) => {
        this.isEditingSuccess = false;
      });
  }
  closeSensorNameModalBox() {
    this.isEditingSensor = false;
    this.currEditSensor = {};
  }
  /* --------------------------------------------------------POWERTRAIN PLATE DETAIlS ENDS------------------------------------------------------------------------------ */
  /* --------------------------------------------------------POWERTRAIN IMAGE BOX STARTS------------------------------------------------------------------------------ */
  closePowertrainImgModalBox() {
    this.closePowertrainImgModal.emit();
  }

  fetchSensorsPositions() {
    this.service
      // .fetchSensorpositions('http://localhost:7777/powertrain/powertrain/sensor-postions/' + this.subsystem_id)
      .fetchSensorpositions(this.sensorpositionUrl + this.subsystem_id)
      .then((res: any) => {
        const {
          device_position,
          Image_path,
          subsystem_name,
          client_id,
          subsystem_uuid,
          su,
        } = res.data;
        this.client_id = client_id;
        this.powertrainImg = Image_path;
        this.powertrainName = subsystem_name;
        this.sensors_img_modal = device_position;
        this.powertrainObj = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onSensorClick(sensor) {
    let allChild = this.oldParams;
    let sensorData = this.oldParams.connected_sensors.filter(
      (s) => s.id == sensor.asset_id
    )[0];
    localStorage.setItem("MacAddress", sensorData.mac_address);
    const assetChilds = allChild.connected_sensors.filter((x) => {
      return x.device_sno != 1;
    });
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        // pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        pageRef: "",
        deviceId: sensorData.inventory_id,
        assetid: sensorData.id,
        label: sensorData.lbl,
        asset_type: sensorData.asset_type,
        sub_type: allChild.sub_type,
        device_serial_no: sensorData.device_sno,
        serial_no: sensorData.sno,
        assetStatus: sensorData.asset_status,
        sensorType: sensorData.sensor,
        no_of_children: assetChilds.length,
        asset_master_info: JSON.stringify(allChild),
        macaddress: sensorData.mac_address,
        kurt_freq: allChild.kurt_freq,
        kurt_threshold: allChild.kurt_threshold,
        kurt_anomaly_counter: allChild.kurt_anomaly_counter,
        route_path: "device-reports",
        outOfService: allChild.out_of_service,
        motor_serial_no: sensorData.motor_serial_no,
        fromPowerTrain: JSON.stringify({
          subsystemId: this.subsystem_id,
          isPowertrainSensor: true,
        }),
      },
    };
    const params = new URLSearchParams({
      Monitoring_window: "true",
    });
    // this.userID === "390" || this.clientId === "390"
    if (
      this.client_id == "390" ||
      localStorage.getItem("associated_clientid") == "390"
    ) {
      localStorage.removeItem("innertab");
      localStorage.removeItem("tab");
      const newWindowUrl = `/#/detail-nxt?${params}`;

      const newWindow = window.open(newWindowUrl, "_blank");

      if (newWindow) {
        newWindow.addEventListener("load", () => {
          newWindow.postMessage(
            { type: "passData", data: navigationExtras },
            window.location.origin
          );

          // Send the second message after a delay
          setTimeout(() => {
            newWindow.postMessage(
              { type: "passData", data: navigationExtras },
              window.location.origin
            );
          }, 1000);
        });
      } else {
        console.error("Failed to open new tab. Pop-up blocker may be enabled.");
      }
    } else {
      this.router.navigate(["detail-nxt"], navigationExtras);
    }
  }

  editPowertrain(): void {
    this.service.updatePowertrainEditData({
      powertrainImg: this.powertrainImg,
      powertrainName: this.powertrainName,
      powertrainId: this.subsystem_id,
      sensors: this.sensors,
      ...this.powertrainObj,
    });

    this.router.navigate(["powertrain-edit"], { skipLocationChange: true });
  }

  showTooltip(sensor: any): string {
    return `
    Sensor:${sensor.assetType}                  
    Mac:${sensor.mac_address}                
    Sr.No:${sensor.motor_serial}               
    Name:${sensor.sensorMarker}
    `;
  }

  opnePowertrainImageModal() {
    this.showModal = true;
  }
  /* --------------------------------------------------------POWERTRAIN IMAGE BOX ENDS------------------------------------------------------------------------------ */

  /* --------------------------------------------------------POWERTRAIN PHYSICAL IMAGE  STARTS---------------------------------------------------------------------------- */
  closePTPhysicalimageModalBox() {
    this.closePowertrainPhyImgModal.emit({ type: "all" });
  }

  goToImageLink(url: string) {
    if (url !== undefined) {
      window.open(url, "_blank");
    }
  }

  upload(files: any, type) {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Token is missing");
      return;
    }
    this.uploader.uploadAll();
    this.uploader.onProgressItem = (progress: any) => {
      let percentDone = progress["progress"];
    };
  }

  private subscription: Subscription = new Subscription();
  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(
      this.http
        .put(signedRequest, files[0], {
          reportProgress: true,
          observe: "events",
        })
        .subscribe((event) => {
          if (event.type === HttpEventType.UploadProgress) {
            let percentDone = Math.round((100 * event.loaded) / event.total);
          } else if (event instanceof HttpResponse) {
            let showCancelBtn = false;
            let fileName = "";
            let uploadSuccess = true;
            let _imgUrl = imageurl;
          }
        })
    );
  }

  initializeUploader() {
    this.uploader = new FileUploader({
      url: this.imageUploadUrl,
      // url: 'http://localhost:3015/images/powertrain',
      authToken: localStorage.getItem("token"),
      disableMultipart: false, // Ensure multipart upload is enabled
    });

    this.uploader.onBuildItemForm = (item, form) => {
      const token = localStorage.getItem("token");
      if (!token) {
      }
      form.append("token", token);
      form.append("user_id", localStorage.getItem("user_id"));
    };

    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      this.uploadLoader = true;
    };
    this.uploader.onCompleteItem = (item, response: any, status, headers) => {
      const imgUrl = JSON.parse(response).body;
      if (status === 200) {
        let client_id = localStorage.getItem("user_id");
        if (client_id) {
          this.service
            .addPhysicalImages(`${this.addPhyImgUrl}${this.subsystem_id}`, {
              url: imgUrl,
            })
            // this.service.addPhysicalImages(`http://localhost:7777/powertrain/powertrain-images/${this.subsystem_id}`,{url:this._imgUrl})
            .then((res: any) => {
              this.closePowertrainPhyImgModal.emit({ type: "savePhyImg" });
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.uploadLoader = false;
            });
          this.srv.showSuccess("Saved successfully");
        }
      } else {
        this.srv.showError("Upload unsuccessfully");
      }
    };

    this.uploader.onProgressItem = (progress) => {
    };
  }

  deletePTPhysicalimageModalBox() {
    this.service
      .deletePhysicalImages(`${this.deletePhyImg}${this.data.id}`)
      .then((res) => {
        this.srv.showSuccess("Delete Successfully");
        this.closePowertrainPhyImgModal.emit({ type: "savePhyImg" });
      });
  }
  /* --------------------------------------------------------POWERTRAIN PHYSICAL IMAGE  ENDS------------------------------------------------------------------------------ */
  /* --------------------------------------------------------POWERTRAIN COMMISSION DATE STARTS------------------------------------------------------------------------------ */
  saveCommissionDate() {
    if(this.commission_date==null || this.commission_date=="" || this.commission_date==undefined){
      this.srv.showError("Please select a date");
      return;
    }
    this.service
      .updatePtCommissionDate(`${this.powertrain_base_url}commission_date`,this.subsystem_id, this.commission_date)
      .then((res) => {
        if (res.error == false) {
          this.srv.showSuccess("Commission Date Updated!");
          this.closeCommissionDate.emit({reload:true});
        }
      });
    }
    
    closeCommissionModal(){
    this.closeCommissionDate.emit({reload:false});
  }
  /* --------------------------------------------------------POWERTRAIN COMMISSION DATE ENDS------------------------------------------------------------------------------ */
  /* --------------------------------------------------------POWERTRAIN COMMISSION DATE STARTS------------------------------------------------------------------------------ */
  saveOutForServiceData() {
    // isOutForService:: is the original state recieved from db not the one which we recieved by changing toggle
    if (this.data.isOutForService == true) {
      // Was in service not we are toggling it off
      this.service
        .toggleOffOFS(
          `${this.powertrain_base_url}failures/${this.subsystem_id}`,
          this.subsystem_id,
          this.data.last_record_id,
          new Date().toISOString()
        )
        .then((res) => {
          if (res.error == false) {
            this.srv.showSuccess("TOGGLE OFF Updated!");
            this.closeOutForServiceModal.emit({reload:true });
          }
        });
    } else {
      // we are putting it in service so toggle was initially off and we are turing it on
      this.service
        .toggleONOFS(`${this.powertrain_base_url}failures/${this.subsystem_id}`,this.subsystem_id, new Date().toISOString())
        .then((res) => {
          if (res.error == false) {
            this.srv.showSuccess("TOGGLE ON Updated!");
            this.closeOutForServiceModal.emit({reload:true});
          }
        });
    }
  }

  closeOFSModal(){
    this.closeOutForServiceModal.emit({reload:false });
  }
  /* --------------------------------------------------------POWERTRAIN COMMISSION DATE ENDS------------------------------------------------------------------------------ */
  /* --------------------------------------------------------POWERTRAIN YTD V2 STARTS------------------------------------------------------------------------------ */

  endDateValidator(control: AbstractControl): ValidationErrors | null {
    const formGroup = control.parent;
    if (!formGroup) return null;
    
    const startDate = formGroup.get('start_date')?.value;
    const endDate = control.value;
    
    if (!startDate || !endDate) return null;
    
    return new Date(endDate) <= new Date(startDate) 
      ? { endDateInvalid: 'End date must be after start date' } 
      : null;
  }
  startDateValidator(control: AbstractControl): ValidationErrors | null {
    const formGroup = control.parent;
    if (!formGroup) return null;
    
    const startDate = control.value;
    const endDate = formGroup.get('end_date')?.value;
    
    if (!startDate || !endDate) return null;
    
    return new Date(startDate) >= new Date(endDate) 
      ? { startDateInvalid: 'Start date must be before end date' } 
      : null;
  }
  getTodayFormatted(): string {
    const today = new Date();
    // Format: YYYY-MM-DDThh:mm
    return today.getFullYear() + '-' + 
           String(today.getMonth() + 1).padStart(2, '0') + '-' + 
           String(today.getDate()).padStart(2, '0') + 'T' + 
           String(today.getHours()).padStart(2, '0') + ':' + 
           String(today.getMinutes()).padStart(2, '0');
  }
  submitYTDMetrics(){
    const {subsystem_id}=this.data
    const {start_date,end_date,cost}=this.YTDMetricsFormV2.value
    this.service
      .updateYTDMetrics(
        this.updateYTDMetricsUrl + this.data.subsystem_id,
        // `http://localhost:7777/powertrain/ytd-failures/${subsystem_id}`,
        {start_date,end_date,cost,subsystem_id}
      )
      .then((res:any) => {
        if(res.status=='success')
          this.closeYTDBox.emit({reload:true})
        this.toast.showSuccess("Performance metrics updated");
      })
      .catch((_) => {
        this.toast.showError("Failed to update Performance metrics");
      });
  }

  closeYTDModal(){
    this.closeYTDBox.emit({reload:false})
  }
  /* --------------------------------------------------------POWERTRAIN YTD V2 ENDS------------------------------------------------------------------------------ */
}
